import React from "react";
import upArrow from "../../../asset/images/up-arrow.svg";
import downArrow from "../../../asset/images/down-arrow-red.svg";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import { Constants } from "../../../CommonMethhods/Constants";
import SmallLoader from "../../../Components/Common/smallLoader";

function PartnerInvestmentSnapshot(props) {
  const investment = props.investmentSnapshot;
  const smallLoader = props.loader;

  const profitAndLoss =
    investment?.pnl === undefined || null ? "0" : investment?.pnl;

  return (
    <>
      <div className="card-box bottom-25 investment-card-wrapper">
        <div className="card-title investment-title">
          <div className="figure-inlac">
            <h2>{Constants.Investment_Snapshot}</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          </div>
        </div>
        <div className="investment row">
          <div className="col-12 col-md-4">
            <div className="investment__card grey-card ">
              <h6 className="investment__card__title">
                {Constants.Invested_Amount}
              </h6>
              <p className="values">
                {smallLoader ? (
                  <SmallLoader />
                ) : (
                  <>
                    {" "}
                    {investment?.invAmt === undefined || null
                      ? "0"
                      : numDifferentiation(investment?.invAmt)}
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="investment__card grey-card ">
              <h6 className="investment__card__title">
                {Constants.Current_Value}
              </h6>
              <p className="values">
                {smallLoader ? (
                  <SmallLoader />
                ) : (
                  <>
                    {investment?.currVal === undefined || null
                      ? "0"
                      : numDifferentiation(investment?.currVal)}{" "}
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="investment__card grey-card ">
              <h6 className="investment__card__title">
                {Constants.Profit_Loss}
              </h6>
              <p
                className={`values ${
                  investment?.pnl === 0
                    ? "text-muted"
                    : investment?.pnl < 0
                    ? "red-txt"
                    : "green-txt"
                }`}
              >
                {smallLoader ? (
                  <SmallLoader />
                ) : (
                  <>{numDifferentiation(profitAndLoss)}</>
                )}
                <span
                  className={
                    investment?.PnlPer === 0
                      ? "text-muted"
                      : investment?.PnlPer < 0
                      ? "red-txt"
                      : "green-txt"
                  }
                >
                  {smallLoader ? (
                    <SmallLoader />
                  ) : (
                    <>
                      {investment.PnlPer === undefined || null
                        ? "0"
                        : investment.PnlPer.toFixed(2)}
                      {/* 37.98 */}%{" "}
                      {investment.PnlPer === 0 ? null : investment.PnlPer <
                        0 ? (
                        <img src={downArrow} alt="Down Arrow" />
                      ) : (
                        <img src={upArrow} alt="Up Arrow" />
                      )}
                    </>
                  )}
                  {/* <img
                    src={
                      investment.PnlPer === 0
                        ? ""
                        : investment.PnlPer < 0
                        ? downArrow
                        : upArrow
                    }
                    alt=""
                  /> */}
                  {/* <i className="icon-up-triangle"></i> */}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerInvestmentSnapshot;
